import { useLive } from './useLive.js'
import { useSafeLocalStorage } from './useSafeLocalStorage.js'

const isPhoneVotesShape = (v: Record<string, number>) =>
  typeof v === 'object' && v !== null && !Array.isArray(v)

export const usePhoneVotesCast = () => {
  const { name } = useLive()
  return useSafeLocalStorage<Record<string, number>>(
    `2026phoneVotes-${name ?? 'unknown'}`,
    {},
    isPhoneVotesShape,
  )
}
